import { responsiveClassNames } from "../../../utilities/props.js";
import s from "./radius.module.css";
const radius = (value) => {
    if (!value)
        return {};
    return {
        classNames: [s.root, ...responsiveClassNames(s, "--radius", value)],
    };
};
export default radius;
